
<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Batch Stock</h6>
        <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Block ID#</label>
                <select class="form-control" v-model="search.batchblockid">
                  <option value="all">
                        All
                    </option>  
                  <option v-for="(itemObj,index) in batchblockid" :key="index" :value="itemObj.batchblockid">
                        {{ itemObj.batchblockid }} - {{ itemObj.blockname }}
                    </option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Batch No#</label>
                <select class="form-control" v-model="search.batchno">
                  <option value="all">
                        All
                    </option>  
                  <option v-for="(itemObj,index) in nurseryBatchList" :key="index" :value="itemObj.batchno">
                        {{ itemObj.batchno }}
                    </option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_datefrom" class="form-control" v-model="search.datefrom">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_dateto" class="form-control" v-model="search.dateto">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " style="float:right;" id="btn_search" @click="getBatchStockList">Search</button>
            </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Batch No#
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Stock In
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Stock Out
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Details
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Date
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in paginatedBatchStock" :key="index">
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ ((currentPage-1)*perPage) + index +1 }}. {{ item.batchno }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        Block: {{ item.block }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <h5 class="text-xs font-weight-bold mb-0">{{ item.status == 0 ? item.quantity : 0 }} Pokok</h5>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <h5 class="text-xs font-weight-bold mb-0">{{ item.status != 0 ? item.quantity : 0 }} Pokok</h5>
                  <h5 class="text-xs font-weight-bold mb-0" v-show="item.status == 1">RM {{ item.status == 1 ? item.unitprice : 0.00 }}</h5>
                  <h5 class="text-xs font-weight-bold mb-0" v-show="item.status == 1">{{ item.status == 1 ? item.customer : "" }}</h5>
                </td>
                <td class="align-middle" style="max-width: 25%; width: 25%; white-space: normal; word-wrap: break-word;">
                  <p class="text-xs font-weight-bold mb-0">Remark: {{ item.remark }}</p>
                  <p class="text-xs font-weight-bold mb-0" v-show="item.status == 1">Reference: {{ item.reference }}</p>
                </td>
                <td class="align-middle" style="max-width: 10%; width: 10%; white-space: normal; word-wrap: break-word;">
                  <p class="text-xs font-weight-bold mb-0">{{ item.date }}</p>
                </td>
                <td class="align-middle" style="max-width: 5%; width: 5%; white-space: normal; word-wrap: break-word;">
                  <RouterLink :to="{path : '/editSawitBuah/'+ item.batchno}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit Sawit Buah"
                    >Edit
                  </RouterLink>
                </td>
              </tr>
              
            </tbody>
          </table>
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'stockSelect',
  data(){
    return {
      totalRows: 0,
      currentPage: 0,
      perPage: 10,
      searchQuery:'',
      batchStockList: [],
      batchblockid:[],
      nurseryBatchList: [],
      search:{
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          batchno: 'all',
          batchblockid: 'all'
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.batchStockList.length / this.perPage);
    },
    paginatedBatchStock() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.batchStockList.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getBatchStockList();
    this.listAllBatchProfile();
  },
  methods: {

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getBatchStockList(){
      var vbatchno = '%';
        if(this.search.batchno != '' && this.search.batchno != 'all'){
            vbatchno = this.search.batchno;
        }
      var vbatchblockid = '%';
        if(this.search.batchblockid != '' && this.search.batchblockid != 'all'){
            vbatchblockid = this.search.batchblockid;
        }
        console.log('nursery/listAllBatchStock/' + this.search.datefrom + "/" + this.search.dateto + "/" +  vbatchno + "/" + vbatchblockid);
        axios.get('nursery/listAllBatchStock/' + this.search.datefrom + "/" + this.search.dateto + "/" +  vbatchno + "/" + vbatchblockid)
            .then(res => {
              console.log(res.data.batchStockList);
              this.batchStockList = res.data.batchStockList;
              this.totalRows = res.data.batchStockList.length;
              this.currentPage = 1;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    listAllBatchProfile(){
        this.nurseryBatchList = [];
        axios.get('nursery/listAllNurseryBatchActiveStatus')
            .then(res => {
                this.nurseryBatchList = res.data.nurseryBatchList;
                this.search.batchno = 'all';
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
            
        this.batchblockid = [];
        axios.get('nursery/listAllBatchBlockId')
            .then(res => {
                this.batchblockid = res.data.batchblockid;
                this.search.batchblockid = 'all';
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
  },
}
</script>
  